export default __webpack_public_path__ + "static/media/candidateSignUpCover.35cedb26.svg";